<template>
  <Modal 
    :id="'cmp-catalog-licence-add-account'" 
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('vat_report')}}</template>
    <template slot="body">

       
        <TextField
          class="m1"
          :id="'date'"
          type="date"
          v-bind="textFieldConfig"
        
          :value="dateValue"
          :placeholder="$t('date')"
          @valuechanged="onTextFieldValueChange"
          
        />
    
    </template>
    <template slot="options">
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >{{$t('cancel')}}</button>
      <button
        class="dt-button v1 s6"
         :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid"
        @click.stop="onOKClick"
      >
        {{$t('ok')}}
      </button>

    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';

import {
  createTV,
  tv,
} from "../../../../models/text-value.model";
import { format } from 'date-fns';
import { getBaseUrl } from '../../../../services/http/http-client';
import { SETTINGS_URL } from '../../../../services/common-urls';
export default {
  components: {
    Modal,
  },
  props: {
    
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
      },

      dateValue:format(new Date(),"YYYY-MM-DD"),
      validationResult: {},
    };
  },
  mounted:async function() {

  },
  computed: {
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },


  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this.dateValue=value
    },
    onCancel: function() {
      console.log(":::")
      this.$emit("cancelled", true);

      
    },
    onOKClick:function() {
      //console.log()

      const url=`${getBaseUrl()}${SETTINGS_URL}?section=settings&action=open_vat_report&date=${this.dateValue}`

      window.open(url)
    
    },
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-catalog-licence-add-account {
}
</style>